class FsScroller extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const swiper = new Swiper(this, {
            slidesPerView: "auto",
            spaceBetween: 20,
            speed: 5000,
            loop: true,
            autoplay: {
                delay: 0,
            },
        });
    }
}
if (!customElements.get('fs-scroller')) {
    customElements.define('fs-scroller', FsScroller);
}

class FSFeatProductSlider extends HTMLElement {
    constructor() {
        super();
        this.mainSwiper = this.querySelector(".fs_main_swiper");
        this.thumbSwiper = this.querySelector(".fs_thumb_swiper");

        this.mainSwiperInstance = null;
        this.thumbSwiperInstance = null;
    }

    connectedCallback() {
        this._initSwiper();

        window.addEventListener("resize", () => {
            this._handleResize();
        });
    }

    _handleResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
            this._initSwiper();
        }, 300);
    }

    _initSwiper() {
        if (this.mainSwiperInstance) {
            this.mainSwiperInstance.destroy(true, true);
        }
        if (this.thumbSwiperInstance) {
            this.thumbSwiperInstance.destroy(true, true);
        }

        this.thumbSwiperInstance = new Swiper(this.thumbSwiper, {
            spaceBetween: 18,
            slidesPerView: window.innerWidth <= 768 ? 4 : "auto",
            direction: window.innerWidth <= 768 ? "horizontal" : "vertical",
            freeMode: true,
            watchSlidesProgress: true,
        });

        this.mainSwiperInstance = new Swiper(this.mainSwiper, {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: this.thumbSwiperInstance,
            },
        });
    }
}
if (!customElements.get('fs-feat-product-slider')) {
    customElements.define('fs-feat-product-slider', FSFeatProductSlider);
}

class FSReviewSlider extends HTMLElement {
    constructor() {
        super();
        this.cards = [...this.querySelectorAll(".fs_review_card")];
    }
    connectedCallback() {
        this._initSwiper();
        this.cards.forEach((card) => {
            card.addEventListener("click", () => {
                this._playVideo(card);
            });
        });
    }
    _initSwiper() {
        var swiper = new Swiper(this, {
            slidesPerView: 1.5,
            spaceBetween: 24,

            // 🔥 smoothness controls
            speed: 600, // transition duration (higher = smoother)
            freeMode: true, // allows natural scrolling feel
            freeModeMomentum: true,
            freeModeMomentumRatio: 0.5,
            freeModeMomentumVelocityRatio: 0.8,

            // 🧠 better touch behavior
            touchRatio: 1,
            touchAngle: 45,
            grabCursor: true,
            resistanceRatio: 0.85,

            // 📱 important for iOS smoothness
            watchSlidesProgress: true,
            watchSlidesVisibility: true,

            breakpoints: {
                768: {
                slidesPerView: 2.5,
                },
                1224: {
                slidesPerView: 3.5,
                spaceBetween: 37,
                },
            },
        });
    }
    _playVideo(currentCard) {
        this.cards.forEach((card) => {
            if (card === currentCard) return;
            card.querySelector("video").pause();
            card.classList.remove("playing");
        });

        const video = currentCard.querySelector("video");

        if (currentCard.classList.contains("playing")) {
            video.pause();
            currentCard.classList.remove("playing");
        } else {
            video.play();
            currentCard.classList.add("playing");
        }
    }
}
if (!customElements.get('fs-reviews-slider')) {
    customElements.define('fs-reviews-slider', FSReviewSlider);
}

class FSAccordion extends HTMLElement {
    constructor() {
        super();
        this.accordionItems = this.querySelectorAll(".fs_accordion_item");
    }
    connectedCallback() {
        this.accordionItems.forEach((item) => {
            item.addEventListener("click", () => {
                this._toggleAccordion(item);
            });
        });
    }
    _toggleAccordion(item) {
        this.accordionItems.forEach((crnt) => {
            if (crnt === item) return;
            crnt.classList.remove("active");
            crnt.querySelector(".content_wrapper").style.height = "0px";
        });

        const height = item.querySelector(".content").clientHeight;
        const wrapper = item.querySelector(".content_wrapper");

        if (item.classList.contains("active")) {
            item.classList.remove("active");
            wrapper.style.height = "0px";
        } else {
            item.classList.add("active");
            wrapper.style.height = height + "px";
        }
    }
}
if (!customElements.get('fs-accordion')) {
    customElements.define('fs-accordion', FSAccordion);
}

class FSHamburger extends HTMLElement {
    constructor() {
        super();
        // this.header = this.closest(".fs_header_section");
        this.mainBtn = document.querySelector(".icon-hamburger[data-open-lang-currency-sidebar]");
    }
    connectedCallback() {
        // this.addEventListener("click", () => {
        //     this._toggleMenu();
        // });

        this.mainBtn.click();
    }
    _toggleMenu() {
        this.header.classList.toggle("active");
    }
}
if (!customElements.get('fs-hamburger')) {
    customElements.define('fs-hamburger', FSHamburger);
}

class FSCart extends HTMLElement {
  constructor() {
    super();
    this.countEl = this.querySelector('.count');
    this.sourceEl = document.querySelector('[data-cart-count]');
  }

  connectedCallback() {
    if (!this.sourceEl) return;
    
    this.updateCount();

    this.observer = new MutationObserver(() => {
      this.updateCount();
    });

    this.observer.observe(this.sourceEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    this.addEventListener('click', () => {
        const originalCart = document.querySelector('[data-cart-sidebar]');
        if (originalCart) originalCart.click();
    });
  }

  updateCount() {
    const count = this.sourceEl.textContent.trim();
    this.countEl.textContent = count;
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}
if (!customElements.get('fs-cart')) {
    customElements.define('fs-cart', FSCart);
}

class FSTestimonialSlider extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this._initSwiper();
    }
    _initSwiper() {
        var swiper = new Swiper(this, {
            slidesPerView: 3.08,
            spaceBetween: 48,
        });
    }
}
if (!customElements.get('fs-testimonial-slider')) {
    customElements.define('fs-testimonial-slider', FSTestimonialSlider);
}